import { render, staticRenderFns } from "./ProcessesDatatable.vue?vue&type=template&id=5e29cd46"
import script from "./ProcessesDatatable.vue?vue&type=script&lang=js"
export * from "./ProcessesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports